import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Box, Button, Stack, Typography } from "@mui/material";
import packageJson from "../../package.json";
import { useTranslation } from "react-i18next";

function Login() {
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const routeParameter = id !== null ? `?id=${id}` : "";

  return (
    <Box
      sx={{
        backgroundColor: "#e5e7eb",
        p: 2,
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: 4,
          height: "calc(100vh - 32px)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Box sx={{ mb: 6 }}>
          <img src={"/glslogo.png"} width={"65px"} />
        </Box>
        <Box sx={{ mb: 7 }}>
          <Typography
            variant={"h6"}
            sx={{ color: "#061ab1" }}
          >
            Welcome to
          </Typography>
          <Typography
            variant={"h2"}
            sx={{ color: "#061ab1", fontWeight: "800", mb: 3, mt: 2 }}
          >
            Lost & Found
          </Typography>
          <Typography
              variant={"h6"}
              sx={{ color: "#061ab1" }}
          >
            Please select your Login Type
          </Typography>
        </Box>

        <Box sx={{}}>
          <Button
            variant="contained"
            color={"secondary"}
            size={"large"}
            fullWidth
            href={`${packageJson.internalUrl}${routeParameter}`}
            target="_self"
            rel="noopener noreferrer"
            sx={{
              mb: 2,
              height: "3em",
              borderRadius: 3,
              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
            }}
          >
            Internal
          </Button>
          <Button
            variant="contained"
            color={"primary"}
            size={"large"}
            fullWidth
            href={`${packageJson.externalUrl}${routeParameter}`}
            target="_self"
            rel="noopener noreferrer"
            sx={{
              height: "3em",
              borderRadius: 3,
              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
            }}
          >
            External
          </Button>
        </Box>
        <Box sx={{
              position: "absolute",
              right: 28,
              bottom: 20,
          }}>
          <Typography variant={"caption"} sx={{ color: "#c2c2c2" }}>
              {packageJson.version}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default Login;
